import React, { useEffect, useContext, useRef } from "react";
import { GetPagePermission } from "../../components/UserPagePermission";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import userPermissionContext from '../../../context/userPermissionContext';
import { KTSVG } from '../../../_metronic/helpers';
import BackendTable from 'react-backend-table';

function LightVehicleMileage() {
    const { jwt, businessUnit } = useContext(userPermissionContext);
    const hasPermission = GetPagePermission('/report-lightVehicleLowMileage');

    const backendTableRef = useRef(null);
    const [formData, setFormData] = React.useState({
        expenseStartDate: "",
        expenseEndDate: ""
    });

    const columns = [
        { title: 'SL', field: 'serial', sortable: false, searchable: false, thStyle: { textAlign: 'center' }, tdStyle: { textAlign: 'center' } },
        { title: 'Vehicle Number', field: 'vehicleNumber', sortable: true, searchable: true },
        { title: 'Business Unit', field: 'projectName', sortable: true, searchable: true },
        { title: 'Vehicle Type', field: 'vehicleType', sortable: true, searchable: true },
        { title: 'Brand', field: 'productName', sortable: true, searchable: true },
        { title: 'Year of Manufacture', field: 'yearOfManufacture', sortable: true, searchable: true },
        { title: 'CC of Vehicle', field: 'engineCCDisplacement', sortable: true, searchable: true },
        { title: 'Total Fuel Cost', field: 'totalFuelCost', sortable: true, searchable: true, thStyle: { textAlign: 'right' }, tdStyle: { textAlign: 'right' } },
        { title: 'Total Fuel (Liter)', field: 'totalFuelLiter', sortable: true, searchable: true, thStyle: { textAlign: 'right' }, tdStyle: { textAlign: 'right' } },
        { title: 'Monthly Total Run (km)', field: 'monthlyTotalRun', sortable: true, searchable: true, thStyle: { textAlign: 'right' }, tdStyle: { textAlign: 'right' } },
        { title: 'Per Liter Running (km)', field: 'perLiterRunning', sortable: true, searchable: true, thStyle: { textAlign: 'right' }, tdStyle: { textAlign: 'right' } },
    ];

    const options = {
        url: process.env.REACT_APP_API_URL + 'lightVehicleLowMileageReport?currentProject=' + businessUnit.idProjects,
        authorization: 'Bearer ' + jwt.token,
        perPage: [50, 100, 500, 1000, 'All'],
        orderBy: 'perLiterRunning',
        orderType: 'asc',
        columnSearch: true,
        extraData: formData
    };

    useEffect(() => {
        if (formData.expenseStartDate !== "" || formData.expenseEndDate !== "") {
            backendTableRef.current?.reload();
        }
    }, [formData.expenseStartDate, formData.expenseEndDate]);

    useEffect(() => {
        backendTableRef.current?.reload();
    }, [businessUnit]);

    return (
        <>
            {hasPermission === 1 &&
                <div className="card card-custom">
                    <div className='card-header d-flex flex-direction-row justify-content-between py-4'>
                        <div className='card-title w-50'>
                            <KTSVG
                                path="/media/svg/icons/Shopping/Money.svg"
                                className="svg-icon-1 svg-icon-primary"
                            />
                            <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                                LIGHT VEHICLE LOW MILEAGE REPORT
                            </span>
                        </div>
                    </div>

                    <div className="ml-12">
                        <div className="card-body">
                            <div className="form-group row mt-5">
                                <label htmlFor="expenseStartDate" className="col-lg-4 col-form-label" style={{ "textAlign": "right" }}>Expense Start Date</label>
                                <div className="col-lg-4">
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="expenseStartDate"
                                        name="expenseStartDate"
                                        value={formData.expenseStartDate}
                                        onChange={(e) => setFormData({ ...formData, expenseStartDate: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mt-5">
                                <label htmlFor="expenseEndDate" className="col-lg-4 col-form-label" style={{ "textAlign": "right" }}>Expense End Date</label>
                                <div className="col-lg-4">
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="expenseEndDate"
                                        name="expenseEndDate"
                                        value={formData.expenseEndDate}
                                        onChange={(e) => setFormData({ ...formData, expenseEndDate: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className='' style={{ overflowX: "hidden" }}>
                                <BackendTable ref={backendTableRef} columns={columns} options={options} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                hasPermission === 0 &&
                <div className='card card-custom' style={{ padding: "15px" }} >
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40} ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            }
        </>
    );
}

export default LightVehicleMileage;
